import { useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { deletingPaycodeDistribution } from 'utils/PaycodeDistribution'

const Delete = ({open, setOpen, selectedRow, reloading}) => {
    const { t } = useTranslation()
    const [loadingDeletingPaycodeDistribution, setLoadingDeletingPaycodeDistribution] = useState(false)

    return (
        <>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
            >
                <DialogTitle>
                    <Typography variant='body3'>{ t('settings.paycode_distribution.dialog.titles.delete') }</Typography>
                </DialogTitle>

                <DialogContent>
                    <Typography variant='body1'>
                        {t('settings.paycode_distribution.dialog.alerts.delete.message')}
                    </Typography>

                    <ul>
                        { selectedRow.map((pd, index) =>
                            <li key={index}>
                                {pd.name}
                            </li>
                        )}
                    </ul>
                </DialogContent>

                <DialogActions sx={{pb: 2, pr: 3}}>
                    <Button
                        variant='contained'
                        disableElevation
                        onClick={() => {
                            deletingPaycodeDistribution(
                                setLoadingDeletingPaycodeDistribution,
                                selectedRow,
                                () => { setOpen(false) },
                                reloading
                            )
                        }}
                        color='error'
                        loading={loadingDeletingPaycodeDistribution}
                    >
                        {t('general.buttons.delete')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export { Delete }